export type LatLng = {
  lat: number;
  lng: number;
};

export type DelineatorDeviceType = 'cone' | 'barrel' | 'bollard' | 'delineator' | 'yellow_dot';

export type DelineatorGeometryType = 'line' | 'spline' | 'bezier';

export interface DelineatorLine {
  id: string;
  deviceType: DelineatorDeviceType;
  path: LatLng[];  // Click points defining the line
  spacing: number;      // Distance between devices in meters (default 3m)
  deviceSize: number;   // Scale factor for device markers (default 1.0)
  geometryType: DelineatorGeometryType;
}

export interface DelineatorDraft {
  deviceType: DelineatorDeviceType;
  path: LatLng[];  // Points placed so far
  spacing: number;
  deviceSize: number;
  geometryType: DelineatorGeometryType;
}

export interface DelineatorInput {
  deviceType: DelineatorDeviceType;
  path: LatLng[];
  spacing: number;
  deviceSize: number;
  geometryType: DelineatorGeometryType;
}

// Default values for new delineator lines
export const DEFAULT_DELINEATOR_SPACING = 3; // 3 meters
export const DEFAULT_DELINEATOR_SIZE = 1.0;
export const DEFAULT_DELINEATOR_DEVICE = 'cone' as DelineatorDeviceType;
export const DEFAULT_DELINEATOR_GEOMETRY = 'line' as DelineatorGeometryType;
